module.exports = __webpack_public_path__ + "media/images/icon__delete--rb-orange@2x-cd0020dbb3e53aee97af3477f2a95d5f.png";